




















import { Component,  Vue, Prop, Watch } from 'vue-property-decorator';
import { hotBusSite, stations } from '@/api/api';
import { Notify } from 'vant';
import loading from '@/components/loading/loading.vue';

@Component({
    name: 'qsite',
    components: {
        loading
    }
})

export default class Qsite extends Vue {
    private value: string = '';
    private loading: boolean = true;
    private hotStations: any[] = [];
    private show: boolean = false;
    private stations: any[] = [];
    private siteName: string = '';
    
    // mounted
    private mounted() {
        const areaCode: any = localStorage.getItem('areaCode');
        hotBusSite(areaCode).then((res: any) => {
            this.hotStations = res.data;
            this.loading = false;
        });
    }

    // methods
    // 获取站点
    private getStations(val: string): void {
        const areaCode = localStorage.getItem('areaCode');
        const siteName = val;
        stations({areaCode, siteName}).then((res: any) => {
            // console.log(res);
            const data: any[] = res.data;
            this.stations = data;
        });
    }
    // 输入框获得焦点时间
    private focus(): void {
        this.show = true;
    }
    // 输入框失去焦点事件
    private blur(): void {
        setTimeout(() => {
            this.show = false;
            this.value = this.siteName;
        }, 100);
    }
    // 输入框输入内容
    @Watch('value', { deep: true })
    private onValueChanged(val: string, oldVal: string) {
        if (val) {
            this.getStations(val);
        } else {
            this.stations = [];
        }
    }
    // 选择站点
    private chooseStation(name: string): void {
        this.value = name;
        this.siteName = name;
    }
    // 查询
    private search(): void {
        const value: string = this.siteName;
        if (!value) {
            Notify('输入站点名称');
            return;
        }
        this.query(value);
    }
    private query(siteName: string): void {
        this.$router.push({
            path: '/qsiteResult',
            query: {
                siteName
            }
        });
    }
    // 数组去重
    // private arrayUnique(arr: any, name: any): any {
    //     const res = new Map();
    //     return arr.filter((a: any) => !res.has(a.name) && res.set(a.name, 1));
    // }
}
